module.exports = __webpack_public_path__ + "static/media/www.k-ruoka.fi.supermarket.d7a96e40.png";